import { getFunctions, httpsCallable } from 'firebase/functions';
import { auth } from './firebase';

/** Avoid repeated Cloud Function sync calls per browser session for the same uid. */
let rfqSupplierClaimSyncedForUid: string | null = null;

/**
 * Sync `rfqSupplierOrgId` from Firestore into the JWT (when missing/stale), then refresh the token.
 * Storage rules check this claim first; test accounts created outside the invite flow often lack it.
 */
export async function prepareSupplierQuoteUpload(expectedOrgId: string): Promise<void> {
  const user = auth.currentUser;
  if (!user || user.isAnonymous) {
    throw new Error('Sign in to upload quotes.');
  }

  try {
    if (rfqSupplierClaimSyncedForUid !== user.uid) {
      const functions = getFunctions(undefined, 'us-central1');
      const sync = httpsCallable<Record<string, never>, { rfqSupplierOrgId?: string | null }>(
        functions,
        'syncRfqSupplierOrgClaim',
      );
      await sync({});
      rfqSupplierClaimSyncedForUid = user.uid;
    }
  } catch (err) {
    rfqSupplierClaimSyncedForUid = null;
    console.warn('[prepareSupplierQuoteUpload] claim sync failed:', err);
  }

  await user.getIdToken(true);
  const token = await user.getIdTokenResult();
  const claimOrg =
    typeof token.claims.rfqSupplierOrgId === 'string' ? token.claims.rfqSupplierOrgId.trim() : '';
  if (claimOrg && claimOrg !== expectedOrgId) {
    throw new Error('Your account is linked to a different supplier organization.');
  }
}
